var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer-loader font-weight-bold"},[_c('div',{staticClass:"box-bouncing"}),_vm._v("\n\n  Een moment geduld...\n")])
}]

export { render, staticRenderFns }